import { createJSONRequest } from '../../../api/create-request.js'

const BASE_URL = '/api/legal-policy-announcements'

export const fetchAll = () => createJSONRequest({
  method: 'GET',
  url: BASE_URL,
})

export const fetchDraft = () => createJSONRequest({
  method: 'GET',
  url: `${BASE_URL}/draft`,
})

export const create = (data: {
  message: string
  scheduled_date: string
  requires_acceptance: boolean
  terms_of_use_policy_id?: number | null
  privacy_policy_id?: number | null
  cookie_policy_id?: number | null
}) => createJSONRequest({
  method: 'POST',
  url: BASE_URL,
  data,
})

export const update = (id: number, data: Record<string, unknown>) => createJSONRequest({
  method: 'PUT',
  url: `${BASE_URL}/${id}`,
  data,
})

export const remove = (id: number) => createJSONRequest({
  method: 'DELETE',
  url: `${BASE_URL}/${id}`,
})

export const fetchPending = () => createJSONRequest({
  method: 'GET',
  url: `${BASE_URL}/pending`,
})

export const acceptAnnouncement = (id: number) => createJSONRequest({
  method: 'POST',
  url: `${BASE_URL}/${id}/accept`,
})
